(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel(section) {
      var grid = section.querySelector('.collection-cards__grid');
      var dotsContainer = section.querySelector('.collection-cards__dots');
      if (!grid || !dotsContainer) return;

      var cards = Array.from(grid.querySelectorAll('.collection-card'));
      var dots = Array.from(dotsContainer.querySelectorAll('.collection-cards__dot'));

      function updateDots(index) {
        dots.forEach(function(dot, i) {
          dot.classList.toggle('collection-cards__dot--active', i === index);
        });
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            updateDots(cards.indexOf(entry.target));
          }
        });
      }, { root: grid, threshold: 0.5 });

      cards.forEach(function(card) { observer.observe(card); });

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
    }

    document.querySelectorAll('.collection-cards-section').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-links-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initNLBCarousel(wrapper) {
    var nav = wrapper.querySelector('.nav-links-bar');
    if (!nav) return;
    var items = Array.from(nav.querySelectorAll('.nav-links-bar__item:not(.nav-links-bar__item--hide-mobile)'));
    if (items.length <= 1) {
      wrapper.querySelector('.nlb-arrow--prev').hidden = true;
      wrapper.querySelector('.nlb-arrow--next').hidden = true;
      if (items[0]) items[0].classList.add('nav-links-bar__item--active');
      return;
    }

    var current = 0;

    function show(index) {
      items.forEach(function(item, i) {
        item.classList.toggle('nav-links-bar__item--active', i === index);
      });
      wrapper.querySelector('.nlb-arrow--prev').disabled = index === 0;
      wrapper.querySelector('.nlb-arrow--next').disabled = index === items.length - 1;
      current = index;
    }

    wrapper.querySelector('.nlb-arrow--prev').addEventListener('click', function() {
      if (current > 0) show(current - 1);
    });

    wrapper.querySelector('.nlb-arrow--next').addEventListener('click', function() {
      if (current < items.length - 1) show(current + 1);
    });

    show(0);
  }

  function isMobile() { return window.innerWidth <= 740; }

  function init() {
    document.querySelectorAll('.nav-links-bar-wrapper').forEach(function(wrapper) {
      if (isMobile()) initNLBCarousel(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('newsletter-banner-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var input = form.querySelector('input[type="email"]');
      var errorEl = form.querySelector('.newsletter-banner__error');
      var email = input ? input.value.trim() : '';

      if (!email || !input.validity.valid) {
        errorEl.textContent = 'Veuillez saisir une adresse e-mail valide.';
        errorEl.hidden = false;
        input.focus();
        return;
      }

      errorEl.hidden = true;

      var registerUrl = form.dataset.registerUrl || '/account/register';
      window.location.href = registerUrl + '?nb_email=' + encodeURIComponent(email);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.parallax__video').forEach(function(video) {
      if (video.paused) {
        video.play().catch(function() {});
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.photo-gallery-section').forEach(function(section) {
      var lightbox = section.querySelector('.pg-lightbox');
      if (!lightbox) return;

      var img = lightbox.querySelector('.pg-lightbox__img');
      var counter = lightbox.querySelector('.pg-lightbox__counter');
      var closeBtn = lightbox.querySelector('.pg-lightbox__close');
      var prevBtn = lightbox.querySelector('.pg-lightbox__arrow--prev');
      var nextBtn = lightbox.querySelector('.pg-lightbox__arrow--next');

      // Only items that have a real image (data-src)
      var items = Array.from(section.querySelectorAll('[data-gallery-index][data-src]'));
      var currentIdx = 0;

      if (items.length === 0) return;

      function show(index) {
        currentIdx = Math.max(0, Math.min(index, items.length - 1));
        var item = items[currentIdx];

        img.classList.add('is-loading');
        var newImg = new Image();
        newImg.onload = function() {
          img.src = newImg.src;
          img.alt = item.dataset.alt || '';
          img.classList.remove('is-loading');
        };
        newImg.src = item.dataset.src;

        counter.textContent = (currentIdx + 1) + ' / ' + items.length;
        prevBtn.style.visibility = currentIdx === 0 ? 'hidden' : 'visible';
        nextBtn.style.visibility = currentIdx === items.length - 1 ? 'hidden' : 'visible';
      }

      function open(index) {
        show(index);
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      }

      function close() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      // Click on gallery items
      items.forEach(function(item, i) {
        item.addEventListener('click', function() { open(i); });
      });

      closeBtn.addEventListener('click', close);

      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        show(currentIdx - 1);
      });

      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        show(currentIdx + 1);
      });

      // Close on backdrop click
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox || e.target.classList.contains('pg-lightbox__stage')) {
          close();
        }
      });

      // Keyboard navigation
      document.addEventListener('keydown', function(e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(currentIdx - 1);
        if (e.key === 'ArrowRight') show(currentIdx + 1);
      });
    });
  })();

  // ── Mobile carousel dots (photo-gallery) ──
  (function() {
    function initPhotoCarousel(section) {
      var grid = section.querySelector('.photo-gallery__grid');
      var dotsContainer = section.querySelector('.photo-gallery__carousel-dots');
      if (!grid || !dotsContainer) return;

      var items = Array.from(grid.querySelectorAll('.photo-gallery__item'));
      var dots = Array.from(dotsContainer.querySelectorAll('.photo-gallery__carousel-dot'));

      function updateDots(index) {
        dots.forEach(function(dot, i) {
          dot.classList.toggle('photo-gallery__carousel-dot--active', i === index);
        });
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            updateDots(items.indexOf(entry.target));
          }
        });
      }, { root: grid, threshold: 0.5 });

      items.forEach(function(item) { observer.observe(item); });

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
    }

    document.querySelectorAll('.photo-gallery-section').forEach(initPhotoCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.promo-banner__countdown').forEach(function(el) {
    var endDate = new Date(el.getAttribute('data-end')).getTime();

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date().getTime();
      var diff = endDate - now;

      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }

      var days    = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      var d = el.querySelector('[data-days]');
      var h = el.querySelector('[data-hours]');
      var m = el.querySelector('[data-minutes]');
      var s = el.querySelector('[data-seconds]');

      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
